export default __webpack_public_path__ + "static/media/Close.8a2ed51f.svg";